import React, {
    Component
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

// class PMPVendorAccept extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             title: "Preventive Maintenance Planner Accept",
//         }
//     }
//     _doNavToPMPAdd = () => {
//         this.props.navigate("/PMPVendorList");
//     }
//     render() {
//         return (
//             <div className="wrapper">
//                 <Header title={this.state.title} />
//                 <Menu1 />
//                 <div className='content-wrapper'>
//                     <section className='content top-space'>
//                         <div className="m-panel">
//                             <div className="m-panel__body">
//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor="exampleInput">Assign Technician*</label>
//                                             <Select className="form-control "
//                                                     showSearch
//                                                     onChange={this._doSelectVender}
//                                                     placeholder="-- Please Select Technician--"
//                                                     optionFilterProp="children"
//                                                     filterOption={(input, option) =>
//                                                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                                     }
//                                                 >
//                                                     <Option value='1'>Technician 1</Option>
//                                                     <Option value='2'>Technician 2</Option>
//                                                     <Option value='3'>Technician 3</Option>
//                                                     <Option value='4'>Technician 4</Option>
//                                                     <Option value='5'>Technician 5</Option>   
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Add comment*</label>
//                                             <input type="text" className="form-control" />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-md-12 text-right">
//                                 <div className="m-page__button top-space">
//                                     <button type='button' onClick={this._doNavToPMPAdd} className='btn muted-button  deca-btn-orange'>Back</button>
//                                     <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </section>
//                 </div>
//                 <Footer />
//             </div>
//         )
//     }
// }

// export default PMPVendorAccept;



function PMPVendorAccept() {
    const title = "Preventive Maintenance Planner Accept"
    const navigate = useNavigate()
    const _doNavToPMPAdd = () => {
        navigate("/PMPVendorList");
    }
    const _doSelectVender = () => {
        
    }
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            <div className='content-wrapper'>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="exampleInput">Assign Technician*</label>
                                        <Select className="form-control "
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select Technician--"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value='1'>Technician 1</Option>
                                                <Option value='2'>Technician 2</Option>
                                                <Option value='3'>Technician 3</Option>
                                                <Option value='4'>Technician 4</Option>
                                                <Option value='5'>Technician 5</Option>   
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Add comment*</label>
                                        <input type="text" className="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <div className="m-page__button top-space">
                                <button type='button' onClick={_doNavToPMPAdd} className='btn muted-button  deca-btn-orange'>Back</button>
                                <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default PMPVendorAccept
